export const SECURITY_COMPLIANCE_BUNDLES = [
  {
    minUserTier: "5 Users",
    pricePerUser: "$110",
    license: "M365 Business Premium",
    firewall: "Enterprise  EDGE Firewall | EDR | MDR",
    supportHours: "3 hrs",
    vCISO: "$3,000/year",
    governance: "1 Vulnerability Scan, Annual Risk Summary",
  },
  {
    minUserTier: "10 Users",
    pricePerUser: "$105",
    license: "M365 Business Premium",
    firewall: "Cisco Meraki or Fortinet",
    supportHours: "5 hrs",
    vCISO: "$3,500/year",
    governance: "1 Pen Test, Bi-Annual Vuln Scan",
  },
  {
    minUserTier: "25 Users",
    pricePerUser: "$125",
    license: "Microsoft 365 E3",
    firewall: "Cisco Meraki or Fortinet",
    supportHours: "10 hrs",
    vCISO: "$10,000/year",
    governance: "Quarterly Vuln Scans, 1 Pen Test, 1 Third-Party Risk Assessment",
  },
  {
    minUserTier: "50 Users",
    pricePerUser: "$150",
    license: "Microsoft 365 E5",
    firewall: "Cisco Meraki or Fortinet",
    supportHours: "25 hrs",
    vCISO: "$15,000/year",
    governance: "Quarterly Vuln Scans, 2 Pen Tests, 1 Third-Party Risk Assessment",
  },
];
